<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h1>
              Users
              <router-link :to="{ name: 'UserAdd' }" class="btn ml-auto">
                <i class="icon-plus"></i> New
              </router-link>
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Users</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div
            class="card-header py-3"
            v-if="!_.isEmpty(list.data) && is_loading == false"
          >
            <a
              href="javascript:void(0)"
              class="btn btn-info"
              @click="show_filter = !show_filter"
              ><i class="fa fa-filter"></i>Filter</a
            >
            <div class="card-tools">
              <button class="btn btn-outline" @click="exportFile()">
                <i class="icon-download"></i> Export
              </button>
            </div>
          </div>
          <form @submit.prevent="setFilters" method="GET" novalidate>
            <div class="card-body" v-if="show_filter">
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="username">Username</label>
                    <div class="col-md-9">
                      <input
                        type="text"
                        class="form-control"
                        id="username"
                        v-model="filter.username"
                        placeholder="username"
                      />
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="name">Name</label>
                    <div class="col-md-9">
                      <input
                        type="text"
                        class="form-control"
                        id="name"
                        v-model="filter.name"
                        placeholder="Name"
                      />
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="mobile_no"
                      >Mobile No</label
                    >
                    <div class="col-md-9">
                      <input
                        type="text"
                        class="form-control"
                        id="mobile_no"
                        v-model="filter.mobile_no"
                        placeholder="Mobile No"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="email">Email</label>
                    <div class="col-md-9">
                      <input
                        type="text"
                        class="form-control"
                        id="email"
                        v-model="filter.email"
                        placeholder="Email"
                      />
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="role">Role</label>
                    <div class="col-md-9">
                      <el-select
                        v-model="filter.role"
                        name="role"
                        id="role"
                        placeholder="Select role"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="role in roles"
                          :key="role.id"
                          :label="role.role_name"
                          :value="role.id"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <!--<div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="organization">Organization</label>
                    <div class="col-md-9">
                      <multiselect
                        id="organization"
                        v-model="filter.organization_id"
                        :options="pre.organizations.map(org => org.id)"
                        :custom-label="opt => pre.organizations.find(x => x.id == opt).org_name"
                        placeholder="Pick Organization" :searchable="true" :multiple="false"
                        class="email"
                      >
                      </multiselect>
                    </div>
                  </div>-->
                  <!-- Date range -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="created_at"
                      >Created at Range</label
                    >
                    <div class="col-md-9">
                      <date-picker
                        type="datetime"
                        input-class="form-control"
                        v-model="filter.created_at"
                        range
                        lang="en"
                        format="YYYY-MM-DD hh:mm:ss"
                        confirm
                        id="created_at"
                        value-type="YYYY-MM-DD hh:mm:ss"
                      ></date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9 offset-md-3">
                      <button type="submit" class="btn mr-3">
                        <i class="icon-search"></i> Search
                      </button>
                      <button type="reset" class="btn btn-outline" @click="resetFilter()">
                        <i class="icon-refresh"></i>
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <div class="card-body">
            <div v-if="!_.isEmpty(list.data) && is_loading == false">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th style="width: 10px">ID</th>
                      <th>Username</th>
                      <th>Name</th>
                      <th style="white-space: nowrap">Mobile No</th>
                      <th>Email</th>
                      <th>Parent</th>
                      <th>Organization</th>
                      <th>Roles</th>
                      <!-- <th>Department</th> -->
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody class="users-list">
                    <tr v-for="(val, index) in list.data" :key="index">
                      <td>{{ val.id }}</td>
                      <td>{{ val.username }}</td>
                      <td>{{ val.name }}</td>
                      <td>{{ val.mobile_no }}</td>
                      <td>{{ val.email }}</td>
                      <td>
                        {{ !_.isEmpty(val.parent) ? val.parent.name : "NA" }}
                      </td>
                      <td>
                        {{
                          !_.isEmpty(val.organization) ? val.organization.org_name : ""
                        }}
                      </td>
                      <td>
                        <span
                          class="badge"
                          v-for="(roleValue, roleIndex) in val.roles"
                          :key="roleIndex"
                          >{{ roleValue.name }}</span
                        >
                      </td>
                      <!-- <td>
                        {{
                          !_.isEmpty(val.department) ? val.department.name : ""
                        }}
                      </td> -->
                      <td class="text-right">
                        <router-link
                          :to="{ name: 'UserView', params: { id: val.id } }"
                          class="btn btn-view"
                        >
                          <i class="icon-eye"></i>
                        </router-link>
                        <router-link
                          :to="{ name: 'UserEdit', params: { id: val.id } }"
                          class="btn btn-edit"
                        >
                          <i class="icon-edit"></i>
                        </router-link>
                        <a
                          v-if="1 == 0"
                          class="btn btn-trash"
                          href="javascript:void(0)"
                          @click="deleteUser(val.id, index)"
                          ><i class="icon-trash"></i
                        ></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-2 text-right d-block d-sm-none">
                Swipe <i class="icon-swipe"></i>
              </div>
            </div>
            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>
          <div :class="{ 'card-footer': list.total > list.per_page }">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="getUsers()"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { CommonAPI, RoleAPI } from "@/services/api";
import axios from "axios";
import { Notification } from "element-ui";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
// eslint-disable-next-line @typescript-eslint/no-var-requires
// const fileDownload = require("js-file-download");
import { fileDownload } from "@/utils/CommonUtils";
const filterable = {
  username: "",
  name: "",
  mobile_no: "",
  email: "",
  role: "",
  created_at: "",
};

export default {
  name: "UserList",
  metaInfo: {
    title: "User List | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },
  data: () => ({
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
    },
    order_by: "asc",
    api_url: "",
    show_filter: false,
    roles: {},
    filter: filterable,
    pre: [],
    is_loading: false,
    has_permission: true,
  }),
  watch: {
    "$route.query"() {
      this.getUsers();
    },
  },
  mounted: function () {
    /* if (this.isMobile()) {
      window.$(document).find('.push-menu-class').trigger('click');
    } */
    this.api_url = "/admin_users";
    this.getUsers();
    this.getRoles();
    this.getOrganization();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
    });
    Object.keys(this.$route.query).forEach((key) => {
      if (key in this.filter) {
        this.filter[key] = this.$route.query[key];
        this.show_filter = true;
      }
    });
  },
  methods: {
    exportFile: function () {
      this.is_loading = true;
      const query = { ...this.filter, ...this.$route.query };
      axios
        .get("/admin-users-export", { params: query, responseType: "blob" })
        .then((response) => {
          // console.log(response.data);
          fileDownload(response.data, "admin-users.xlsx");
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {
          this.is_loading = false;
          Notification.success({
            title: "Export Completed",
            message: "Export operation completed successfully",
            type: "success",
          });
        });
    },
    customFormatter(date) {
      // eslint-disable-next-line no-undef
      return moment(date).format("YYYY-MM-DD hh:mm:ss");
    },
    getRoles() {
      RoleAPI.index().then((roles) => {
        this.roles = roles.data.map((role) => {
          return { id: role.id, role_name: role.name };
        });
      });
    },
    getUsers() {
      this.is_loading = true;
      const query = { ...this.filter, ...this.$route.query };
      this.apiUsers(query)
        .then((list) => {
          this.list = list;
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    apiUsers(query = null) {
      return new Promise((resolve, reject) => {
        axios
          .get(this.api_url, {
            params: query,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            if (error.response.status === 403) {
              this.has_permission = false;
            }
            reject(error);
          });
      });
    },
    async getOrganization() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const _this = this;
      await CommonAPI.getAllOrganizations().then((organizations) => {
        _this.pre.organizations = organizations;
      });
    },
    deleteUser: function (id, index) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const _this = this;
      // eslint-disable-next-line camelcase
      const delete_api_url = this.api_url + "/" + id;

      _this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          confirmButtonText: "Yes, delete it!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
        })
        .then((result) => {
          if (result.isConfirmed) {
            _this.is_loading = true;
            axios
              .delete(delete_api_url)
              .then((response) => {
                _this.list.data.splice(index, 1);
                _this.$toaster.success(response.data.message);
                _this.is_loading = false;
              })
              .catch((error) => {
                _this.is_loading = false;
                console.log(error);
                _this.$swal.fire("Failed!", "Failed to delete.", "error");
              });
          }
        });
    },
    async setFilters() {
      await this.$router
        .push({
          path: this.$route.path,
          query: this.filter,
        })
        .catch(() => {});
    },
    resetFilter() {
      this.filter = {};
      this.$router.push({ path: this.$route.path }).catch(() => {});
      this.$root.$emit("show-icon");
      this.show_filter = false;
      /* const query = Object.assign({}, this.$route.query)
      if (Object.keys(query).length > 0) {
        delete query.order_by
        delete query.order_key
        delete query.page
        // Object.keys(query).forEach((key) => delete query.key);
        this.$router.replace({ query })
      }
      this.filter = {}
      this.getUsers() */
    },
  },
};
</script>
